<template>
    <div>
        <div class="mb-6">
            <p class="text-sm">Are you sure you want to send this invoice to the customer?</p>
            <div class="mt-3 rounded-md bg-muval-gray-5 p-3">
                <p class="text-sm text-muval-gray-1">
                    <span class="font-medium">Customer email: </span>
                    <span v-if="customerEmail">{{ customerEmail }}</span>
                    <span
                        v-else
                        class="text-muval-error"
                        >No email address found</span
                    >
                </p>
            </div>
        </div>
        <div class="form-save mt-4">
            <MuvalButton
                quaternary
                @click="closeModal"
            >
                Cancel
            </MuvalButton>
            <div>
                <MuvalButton
                    :loading="loading"
                    :disabled="!customerEmail"
                    @click="sendEmail"
                >
                    Send invoice
                </MuvalButton>
            </div>
        </div>
    </div>
</template>

<script setup>
import MuvalButton from '@buttons/MuvalButton.vue';
import { toast } from 'vue-sonner';

const props = defineProps({
    invoiceId: {
        type: Number,
        required: true,
    },
    customerEmail: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['close:modal', 'email:sent']);
const order = useOrderStore();
const loading = ref(false);

async function sendEmail() {
    loading.value = true;

    try {
        const url = `/orders/${order.getOrderId}/invoices/${props.invoiceId}/send-email`;
        const response = await window.tenantAxios.post(url);

        if (response) {
            toast.success(response.data.message || 'Invoice email sent to customer successfully');
            emit('email:sent');
        }
    } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to send invoice email';
        toast.error(errorMessage);
    } finally {
        loading.value = false;
        closeModal();
    }
}

function closeModal() {
    emit('close:modal');
}
</script>
